import React from 'react';

import useScreenQuery from '../../../hooks/useScreenQuery';
import PlayupThemeProvider from '../../../themes/PlayupThemeProvider';
import { PageContainer } from '../sharedStyles';

import AUView from './AUView';
import USView from './USView';

const PortalTakeABreak = ({ brandName, user, sending = false, errors, handleSubmit, isUS }: PortalTakeABreakProps) => {
	const { isSmall } = useScreenQuery();

	return (
		<PlayupThemeProvider>
			<PageContainer isSmallScreen={isSmall}>
				{isUS ? (
					<USView brandName={brandName} user={user} errors={errors} sending={sending} handleSubmit={handleSubmit} />
				) : (
					<AUView brandName={brandName} user={user} errors={errors} sending={sending} handleSubmit={handleSubmit} />
				)}
			</PageContainer>
		</PlayupThemeProvider>
	);
};

export default PortalTakeABreak;
